import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { Link } from 'react-router-dom';

import { currencyNumberFormat } from '../../../utilities/number-format';
import { OutlineButton, YellowButton } from '../../../components/Buttons';
import Invoice from '../types/invoice';

interface Props {
  invoice: Invoice;
  onPayClick?: () => void;
}

const TableRow = ({ invoice, onPayClick }: Props) => {
  const { dateOfInvoice, service, balance, id, azEncounterIdentifier, paidViaPpApp } = invoice;

  const canPayInvoice = !paidViaPpApp && parseInt(balance) > 0;

  return (
    <tr>
      <TableD>{moment(dateOfInvoice).format('MM/DD/YYYY')}</TableD>
      <TableD>{service}</TableD>
      <TableD>
        {currencyNumberFormat(balance)}
        {canPayInvoice && <PayButton onClick={onPayClick}>PAY</PayButton>}
      </TableD>
      <TableD>
        <ViewButton as={Link} to={`/invoices/${id}`}>
          View details
        </ViewButton>
      </TableD>
      <TableD>{azEncounterIdentifier || id}</TableD>
    </tr>
  );
};

const TableD = styled.td`
  padding: 10px 30px;
`;

const ViewButton = styled(OutlineButton)`
  display: block;
  margin: 0 auto;
  padding: 12px 18px;
`;

const PayButton = styled(YellowButton)`
  margin-left: 32px;
  padding: 12px 32px;
`;

export default TableRow;
